module.exports = {"653130100":"巴楚镇","653130101":"色力布亚镇","653130102":"阿瓦提镇","653130200":"恰尔巴格乡","653130201":"多来提巴格乡","653130202":"阿纳库勒乡","653130203":"夏马勒乡","653130204":"阿克萨克玛热勒乡","653130205":"阿拉根乡","653130206":"琼库恰克乡","653130207":"英吾斯坦乡","653130508":"兵团四十八团","653130103001":"三岔口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653130.json
// module id = 2898
// module chunks = 0